import { useServices } from 'core/services';
import { tokenKeys } from 'core/utils/query-key-factory';
import { useQuery } from '@tanstack/react-query';

export const useGetInvitationTokenStatus = (
	communityId: string,
	tokenId: string
) => {
	const { api } = useServices();

	return useQuery({
		queryKey: tokenKeys.invitationStatus(communityId, tokenId),
		queryFn: () =>
			api
				.getInvitationTokenStatus(communityId, tokenId)
				.then(response => response.data),
		enabled: !!communityId && !!tokenId,
		refetchOnMount: true,
		staleTime: 10000, // 10 seconds
	});
};
